import { Row, Col, Alert } from 'antd';
import type { SimulationDetail } from '../../store/simulation/types';
import { SimulationCard } from './SimulationCard';
import { SimulationExportsTable } from './SimulationExportsTable';

export interface SimulationDetailTabProps {
  simulation: SimulationDetail;
}

export const SimulationExportTab = ({ simulation }: SimulationDetailTabProps) => {
  const isComplete = simulation.simulationStatus === 'completed';
  const isArchived = simulation.simulationStatus === 'archived';
  return (
    <Row gutter={16}>
      <Col span={24}>
        {!isComplete && (
          <Alert
            type={'warning'}
            showIcon={true}
            description={'Export will be available once the simulation has completed execution.'}
            message={'Simulation Incomplete'}
          />
        )}
        {isComplete && (
          <SimulationCard
            heading={'Simulation Exports'}
            subHeading={'Download the results of your simulation.'}
            archived={isArchived}
            bodyStyle={{ padding: 0, borderTop: '1px solid #eee' }}
          >
            <SimulationExportsTable simulation={simulation} />
          </SimulationCard>
        )}
      </Col>
    </Row>
  );
};
